function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import { withField } from './index.js';
import { Input, InputWrapper } from './input.js';
const InputWrapperStyled = styled(InputWrapper).withConfig({
  displayName: "price-input__InputWrapperStyled",
  componentId: "sc-1m4q308-0"
})(["flex:1 1 auto;"]);
const Outer = styled.div.withConfig({
  displayName: "price-input__Outer",
  componentId: "sc-1m4q308-1"
})(["display:flex;align-items:center;position:relative;", "{width:", "px;padding-left:10px;}"], Input, p => p.width);

class PriceInputCmp extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", evt => {
      const {
        value
      } = evt.target;
      this.emitChange(value.replace(/[^\d-,.]/g, '').replace(',', '.'));
    });

    _defineProperty(this, "onBlur", evt => {
      let v = evt.target.value;
      let parsed = parseFloat(v.replace(',', '.'));

      if (isNaN(parsed)) {
        parsed = '';
      }

      this.emitChange(parsed);
    });

    _defineProperty(this, "emitChange", val => {
      const {
        form,
        field,
        onChange,
        identifier
      } = this.props; // keep the if else condition until refactor of variant subscription

      if (identifier) {
        const name = field.name.substring(0, field.name.lastIndexOf('.'));
        form.setFieldValue(name, {
          price: val,
          identifier
        });
        onChange === null || onChange === void 0 ? void 0 : onChange(val);
      } else {
        form.setFieldValue(field.name, val);
        onChange === null || onChange === void 0 ? void 0 : onChange(val);
      }
    });
  }

  render() {
    var _field$value;

    const {
      field = {},
      id,
      form,
      width = 100,
      onChange,
      subscription,
      ...rest
    } = this.props;
    field.value = (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : '';
    return /*#__PURE__*/React.createElement(Outer, {
      width: width
    }, /*#__PURE__*/React.createElement(InputWrapperStyled, null, /*#__PURE__*/React.createElement(Input, _extends({}, field, {
      className: "price-input",
      injectStyles: false,
      id: id || field.name || rest.fieldName,
      autoComplete: "off",
      inputMode: "numeric",
      onChange: this.onChange,
      onBlur: this.onBlur,
      right: true,
      price: true,
      subscription: subscription,
      type: "text"
    }, rest))));
  }

}

export const PriceInput = withField(PriceInputCmp);